module.exports = __webpack_public_path__ + "img/title.4e01214f.png";